import React from 'react';
import ModalGestionarNotasContent from './ModalGestionarNotasContent';

const ModalGestionarNotas = ({ isOpen, onClose }) => {
  console.log('ModalGestionarNotas received isOpen:', isOpen);

  if (!isOpen) return null;

  console.log('ModalGestionarNotas is rendering. isOpen:', isOpen);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4">
      <div className="bg-slate-900 rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col border border-slate-700 overflow-y-auto">
        <ModalGestionarNotasContent onClose={onClose} />
      </div>
    </div>
  );
};

export default ModalGestionarNotas;